export default __webpack_public_path__ + "014efe68ed4c9e728992c490e6a2f422.png";